import React from 'react';
import { HeroIntroStyleListTypes } from '../../utils/utils';
import TextComponent from '../TextComponent/textComponent';
import './heroIntro.scss';

const HeroInro = ({ description, showIcon, linksBtn, layoutStyle }) => {
  const getLayoutStyle = (style) => {
    switch (style) {
      case HeroIntroStyleListTypes.HEROINTROSTYLE1:
        return 'hero-intro-wrapper style-1';
      case HeroIntroStyleListTypes.HEROINTROSTYLE2:
        return 'hero-intro-wrapper style-2';
      case HeroIntroStyleListTypes.HEROINTROSTYLE3:
        return 'hero-intro-wrapper style-3';
      default:
        return 'hero-intro-wrapper';
    }
  };
  return (
    <div className={`${getLayoutStyle(layoutStyle)}`}>
      <div className="container">
        <TextComponent description={description} showIcon={showIcon} linksBtn={linksBtn} />
      </div>
    </div>
  );
};

export default HeroInro;
